import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { ProductPage } from 'src/app/assabil-kernel/models/entities/control-tables/product-page';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductPageRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/product-page-request';


@Component({
  selector: 'app-product-page',
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.scss']
})
export class ProductPageComponent extends BasePage2<ProductPage> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  productPages: ProductPage[] = [];
  // ---------------------------------------------------

//----------------------------------------------------------------------

constructor(
    protected toastr            : ToastrService,
    protected controlService    : ControlTablesService,
    protected router            : Router,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService,
    protected location          : Location) {
    super(toastr, router, baseService, leanUtilsService, location);

    this.entityName  = 'productPage';
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
listFields = [
    { prop: 'rank',               name: 'Rang',               type: 'number'    },
    { prop: 'productPageCode',    name: 'Code',               insertOnly : true },
    { prop: 'name',               name: 'Name'                                  },
    { prop: 'loadable',           name: 'Chargeable',         type: 'boolean'   },
    { prop: 'salable',            name: 'Vendable',           type: 'boolean'   },
    { prop: 'bonus',              name: 'Bonus',              type: 'boolean'   },
    { prop: 'freeGood',           name: 'Produit gratuit',    type: 'boolean'   },
    { prop: 'presenceCheckable',  name: 'Presence',           type: 'boolean'   },
    { prop: 'presenceCheckable2', name: 'Presence 2',         type: 'boolean'   },
    { prop: 'inventoryable',      name: 'Inventoriable',      type: 'boolean'   },
    { prop: 'inventoryable2',     name: 'inventoriable 2',    type: 'boolean'   },
    { prop: 'inventoryable3',     name: 'inventoriable 3',    type: 'boolean'   },
    { prop: 'facingable',         name: 'Facingable',         type: 'boolean'   },
    { prop: 'apos',               name: 'Apos',               type: 'boolean'   },
    { prop: 'consignement',       name: 'Consignement',       type: 'boolean'   },
]
//----------------------------------------------------------------------

//----------------------------------------------------------------------
getRows(): ProductPage[] {
    return this.productPages;
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
new(){
    let entity : ProductPage = new ProductPage();
    entity.inserted = true;
    entity.edit = true;
    this.productPages.push(entity);
    this.productPages = [...this.productPages];
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
saveRow(productPage: ProductPage): Promise<ProductPage> {
    let request  : ProductPageRequest = new ProductPageRequest(this.controlService.getUserInfo());
    request.productPage = productPage;
      return this.controlService.save(this.entityName, request);
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.productPages = result;
        
    }).catch(error => {
        this.showError(error);
    })
}
//----------------------------------------------------------------------

}


